(() => {
  const modal = document.getElementById('WolfNewsletterModal');
  if (!modal || typeof modal.show !== 'function') return;

  const form = modal.querySelector('form');
  const email = modal.querySelector('input[type="email"]');
  const submit = form.querySelector('[type="submit"]');
  const close = modal.querySelector('[id^="ModalClose-"]');
  const error = modal.querySelector('[data-newsletter-error]');
  const success = modal.querySelector('[data-newsletter-success]');
  const description = modal.querySelector('#WolfNewsletterDescription');
  const newsletterUrl = new URL(modal.dataset.newsletterUrl, window.location.origin);
  const allowedOrigins = new Set([window.location.origin, new URL(modal.dataset.shopUrl).origin]);
  const allowedPaths = new Set([newsletterUrl.pathname, '/pages/join-our-mailing-list']);
  let request = null;
  let closeTimer;
  let fadeTimer;

  function clearTimers() {
    clearTimeout(closeTimer);
    clearTimeout(fadeTimer);
  }

  function reset() {
    clearTimers();
    if (request) {
      clearTimeout(request.timeout);
      request.controller.abort();
      request = null;
    }
    modal.dataset.state = 'idle';
    form.hidden = false;
    form.removeAttribute('aria-busy');
    email.readOnly = false;
    email.disabled = false;
    submit.disabled = false;
    error.hidden = true;
    error.textContent = '';
    success.hidden = true;
    description.hidden = false;
    email.removeAttribute('aria-invalid');
    email.removeAttribute('aria-describedby');
  }

  function open(opener) {
    reset();
    modal.show(opener);
    email.focus({ preventScroll: true });
  }

  function showError(message) {
    modal.dataset.state = 'error';
    error.textContent = message;
    error.hidden = false;
    email.setAttribute('aria-describedby', error.id);
  }

  function showSuccess() {
    modal.dataset.state = 'success';
    form.hidden = true;
    description.hidden = true;
    success.hidden = false;
    email.value = '';
    email.disabled = true;
    submit.disabled = true;
    // Refresh the existing focus trap now that the form controls are hidden.
    trapFocus(modal, close);
    closeTimer = setTimeout(() => {
      modal.dataset.state = 'closing';
      fadeTimer = setTimeout(() => modal.hide(), 220);
    }, 2200);
  }

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest?.('.wolf-detail-card__body a[href], .wolf-pdp-content__pickup a[href], .wolf-pdp-content__additional-body a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;

    const url = new URL(link.href, window.location.href);
    if (!allowedOrigins.has(url.origin) || !allowedPaths.has(url.pathname.replace(/\/$/, '')) || url.searchParams.get('view') !== 'newsletter') return;

    event.preventDefault();
    open(link);
  });

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (request || modal.dataset.state === 'success' || modal.dataset.state === 'closing' || !form.reportValidity()) return;

    const companyId = modal.dataset.klaviyoCompanyId;
    const listId = modal.dataset.klaviyoListId;
    if (!companyId || !listId) {
      showError('Signup is temporarily unavailable. Please try again later.');
      return;
    }

    error.hidden = true;
    email.removeAttribute('aria-describedby');
    modal.dataset.state = 'submitting';
    form.setAttribute('aria-busy', 'true');
    email.readOnly = true;
    submit.disabled = true;
    if (modal.hasAttribute('open')) {
      trapFocus(modal, close);
      email.focus({ preventScroll: true });
    }
    const current = { controller: new AbortController() };
    request = current;
    current.timeout = setTimeout(() => current.controller.abort(), 15000);

    try {
      // Public client endpoint: no private API key or optional tracking SDK is used.
      const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(companyId)}`, {
        method: 'POST',
        credentials: 'omit',
        headers: {
          accept: 'application/vnd.api+json',
          'content-type': 'application/vnd.api+json',
          revision: '2026-07-15',
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'PDP Local Pickup newsletter',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email.value.trim(),
                    subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                  },
                },
              },
            },
            relationships: { list: { data: { type: 'list', id: listId } } },
          },
        }),
        signal: current.controller.signal,
      });
      if (request !== current) return;
      // 202 confirms acceptance, including double opt-in; it has no response body.
      if (response.status === 202) {
        showSuccess();
      } else if (response.status === 429) {
        showError('Too many attempts. Please wait a moment and try again.');
      } else {
        showError('We couldn’t complete your signup. Please check your email address and try again.');
      }
    } catch (err) {
      if (request !== current) return;
      showError('We couldn’t confirm your signup. Please check your connection and try again.');
    } finally {
      clearTimeout(current.timeout);
      if (request === current) {
        request = null;
        form.removeAttribute('aria-busy');
        email.readOnly = false;
        submit.disabled = modal.dataset.state === 'success';
        if (modal.dataset.state === 'error' && modal.hasAttribute('open')) {
          trapFocus(modal, close);
          email.focus({ preventScroll: true });
        }
      }
    }
  });

  const hide = modal.hide.bind(modal);
  modal.hide = (...args) => {
    clearTimers();
    if (request) {
      clearTimeout(request.timeout);
      request.controller.abort();
      request = null;
    }
    hide(...args);
  };
  // ModalDialog binds its close button in its constructor; also clean up that path.
  close.addEventListener('click', () => {
    clearTimers();
    if (request) {
      clearTimeout(request.timeout);
      request.controller.abort();
      request = null;
    }
  });

  const url = new URL(window.location.href);
  if (url.searchParams.get('wolf_newsletter') === '1' || url.hash === '#WolfNewsletterForm') {
    open(document.getElementById('MainContent'));
  }
})();
